import { SET_PDF_DIALOG_DATA } from "./types";

export function setPdfDialogData(Data) {
    return {
        type: SET_PDF_DIALOG_DATA,
        Data,
    };
};